import { COLLECTION_IDS } from '@/constants/collections';
import { ISettings } from '@/interfaces/settings.interfaces';

const getDealerCenterParameters = (settings: ISettings, id?: string) => {
  const { spaceId, envId } = settings;
  return {
    spaceId,
    envId,
    collectionId: COLLECTION_IDS.dealersDealership,
    itemId: id,
  };
};

export default getDealerCenterParameters;
